import { useContext, Fragment } from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FFPaper from '../../shared/FFPaper';
import Title from '../../shared/Title';
import NorthEastIcon from '@mui/icons-material/NorthEast';
import KebabMenu, { defaultMenus } from '../../shared/KebabMenu';
import { TrafficAnalyticsContext } from '../../../context/trafficanalytics-context';
import BlueSkeleton from '../../shared/BlueSkeleton';

const handler = (menu: string) => {
  console.log(menu);
}

export default function WeeklySummaryCard() {
  const info = 'Measures the amount of visitors in the current week';
  const { status, data, isFetching } = useContext(TrafficAnalyticsContext);

  return (

    <Grid item={true} xs={12} md={12} sm={12} lg={7} >
      <FFPaper
        sx={{
          minHeight: 240,
          alignItems: 'stretch',
          position: 'relative',
          flexDirection: 'row',
        }}
      >
        <KebabMenu
          menus={defaultMenus}
          handler={handler}
        />
        <Grid container={true} spacing={1}
          sx={{
            display: 'flex', alignItems: 'stretch',
            position: 'relative',
            pt: 1,
          }}>

          {isFetching && <BlueSkeleton width={'100%'} height={'100%'} sx={{ ml: 3, mr: 2 }} />}

          {status === 'success' && !isFetching && <Fragment>
            <Grid item={true}
              xs={12}
              sm={12}
              md={4}
              sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 5 }}
            >
              <Box color="primary" sx={{
                ml: 'auto',
                mr: 'auto',
              }}><Title info={info}>Busiest Day</Title></Box>
              <Box sx={{
                verticalAlign: 'middle',
                textAlign: 'center',
                flexGrow: 1,
                display: 'table',
                mb: 'auto',
                mt: {
                  xs: 2,
                  sm: 'auto',
                  md: 'auto'
                },
              }}>
                <Typography color="secondary" sx={{
                  verticalAlign: 'middle',
                  textAlign: 'center',
                  display: 'table-cell',
                  fontSize: 32,
                  fontWeight: 600,
                  color: (theme) => theme.palette.text.secondary,
                }}>
                  {data?.trafficAnalyticsBusiestDay.value}
                </Typography>
              </Box>
              <Typography color="primary" sx={{
                verticalAlign: 'middle',
                fontSize: 14,
                display: 'block',
                textAlign: 'center',
              }}>vs. Wednesday last week</Typography>
            </Grid>

            <Grid item={true}
              xs={12}
              sm={12}
              md={4}
              sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 5 }}>
              <Box sx={{
                ml: 'auto',
                mr: 'auto',
              }}><Title info={info}>Busiest Hour</Title>
              </Box>
              <Box sx={{
                verticalAlign: 'middle',
                textAlign: 'center',
                flexGrow: 1,
                display: 'table',
                mt: 'auto',
                mb: 'auto',
                borderLeftWidth: {
                  xs: 0,
                  md: 0,
                  lg: 1
                },
                borderLeftColor: 'lightgray',
                borderLeftStyle: 'solid',
              }}>
                <Typography color="secondary" sx={{
                  verticalAlign: 'middle',
                  textAlign: 'center',
                  display: 'table-cell',
                  fontSize: 32,
                  fontWeight: 600,
                  color: (theme) => theme.palette.text.secondary,
                }}>
                  {data?.trafficAnalyticsBusiestHour.value}{ Number(data?.trafficAnalyticsBusiestHour.value) > 12 ? ':00pm': ':00am'}
                </Typography>
              </Box>
              <Typography color="primary" sx={{
                verticalAlign: 'middle',
                fontSize: 14,
                display: 'block',
                textAlign: 'center',
              }}>vs. 12pm last week</Typography>

            </Grid>
            <Grid item={true}
              xs={12}
              sm={12}
              md={4}
              sx={{ display: 'flex', flexDirection: 'column', position: 'relative', pb: 5 }}>
              <Box sx={{
                ml: 'auto',
                mr: 'auto',
              }}><Title info={info}>Face Score</Title>
              </Box>
              <Box sx={{
                verticalAlign: 'middle',
                textAlign: 'center',
                flexGrow: 1,
                display: 'table',
                mt: 'auto',
                mb: 'auto',
                borderLeftWidth: {
                  xs: 0,
                  md: 0,
                  lg: 1
                },
                borderLeftColor: 'lightgray',
                borderLeftStyle: 'solid',
              }}>
                <Typography color="secondary" sx={{
                  verticalAlign: 'middle',
                  textAlign: 'center',
                  display: 'table-cell',
                  fontSize: 32,
                  fontWeight: 600,
                  color: (theme) => theme.palette.text.secondary,
                }}>
                  {Number(data?.trafficAnalyticsFaceScore.value.toLocaleString()) * 100}%
                </Typography>
              </Box>
              <Box sx={{ display: 'block', margin: '0 auto' }}>
                <Typography sx={{
                  backgroundColor: 'success.dark',
                  fontSize: 11,
                  color: 'primary.main',
                  display: 'inline-block',
                  verticalAlign: 'middle',
                  padding: '2px 2px 2px 2px',
                }}>
                  <NorthEastIcon sx={{ color: 'success.light', fontSize: 12, verticalAlign: 'middle' }}
                  />
                  15%
                </Typography>
                <Typography color="primary" sx={{
                  verticalAlign: 'middle',
                  fontSize: 12,
                  textAlign: 'center',
                  display: 'inline',
                  paddingLeft: 1,
                }}>From last week</Typography>
              </Box>

            </Grid>

          </Fragment>}
        </Grid>
      </FFPaper>
    </Grid>
  )
}